/* eslint-disable no-underscore-dangle */
import React, { useContext } from 'react';
import { SbEditableContent } from 'storyblok-react';
import { blokToComponent } from '../../../../helpers';
import { Props } from '../../../../types';
import { PageStateContext } from '../../../../../services';

type PageProps = Props<{ body: SbEditableContent[] }>;

export const Content = ({ blok, getComponent }: PageProps) => {
  const pageContext = useContext(PageStateContext);
  const globalSettings = pageContext?.settings;

  const overviewLink = {
    _uid: `${blok._uid}-overview-link`,
    component: 'roche-button-global',
    appearance: 'tertiary',
    text: globalSettings?.press_articles_overview_link_label,
    href: `/${globalSettings?.press_articles_overview_link_url?.story?.fullSlug}`,
  };

  const aboutRocheLink = {
    _uid: `${blok._uid}-about-roche-link`,
    component: 'roche-button-global',
    text: globalSettings?.press_articles_about_roche_label,
    href: `/${globalSettings?.press_articles_about_roche_url?.story?.fullSlug}`,
  };

  const content = [
    ...(blok.content || []),
  ];

  return <>
    {blokToComponent({
      blok: {
        _uid: `${blok._uid}-content-grid`,
        component: 'roche-grid-8',
        slotted: content,
        remove_padding_top: !blok.image?.filename,
      },
      getComponent,
    })}
    {blokToComponent({
      blok: {
        _uid: `${blok._uid}-about-roche-link-grid`,
        component: 'roche-grid-8',
        remove_padding_top: true,
        slotted: [aboutRocheLink, overviewLink],
      },
      getComponent,
    })}
  </>;
};
